import React from "react";
import { Typography, CircularProgress, Box } from "@mui/material";
import { numberFormat } from "../../../utils/utils";

const ProjectCounterCard = ({
  title,
  value,
  tabLoaders,
  valueprefix = "",
  CardIcon,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        p: "8px 12px",
        borderRadius: "6px",
        border: "1px solid #e0e0e0",
        background: "#fff",
        "& .MuiSvgIcon-root": { color: "#5a7d8a !important", fontSize: "22px !important" },
      }}
    >
      <Box sx={{ mr: 1.5, display: "flex", alignItems: "center" }}>
        {CardIcon}
      </Box>
      <Box sx={{ flex: 1 }}>
        {tabLoaders &&
        tabLoaders.length > 0 &&
        tabLoaders.indexOf("tiles") != -1 ? (
          <CircularProgress size={16} />
        ) : null}
        {(!tabLoaders || !tabLoaders.length || tabLoaders.indexOf("tiles") == -1) && (
          <Typography sx={{ fontWeight: 700, fontSize: "15px", lineHeight: 1.2, color: "#1a1a2e" }}>
            {valueprefix + numberFormat(value)}
          </Typography>
        )}
        <Typography sx={{ fontSize: "11px", color: "#8595A6", lineHeight: 1.3 }}>
          {title}
        </Typography>
      </Box>
    </Box>
  );
};

export default ProjectCounterCard;
